module.exports = __webpack_public_path__ + "static/media/culture.d4037144.png";